// extracted by mini-css-extract-plugin
export default {"root":"GF7JZSkO","item":"v_3L6h4A","label":"TnrDlK1n","value":"rQT8O8bt","link":"Djb1k4y5","empty":"gUe0D5AZ"};